class TaskMessagePermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'task_message.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'task_message._m';

    // Can access archived messages
    static ACCESS_ARCHIVE = 'task_message.access.archive';

    // Can access internal messages
    static ACCESS_INTERNAL = 'task_message.access.internal';

    // Can create non-internal messages
    static CREATE = 'task_message.create';

    // Can create non-internal message if assigned to a task
    static CREATE_MOD_TASK_ASSIGNED = 'task_message.create.mod.task_assigned';

    // Can create internal messages
    static CREATE_INTERNAL = 'task_message.create.internal';

    // Can create internal messages if assigned to a task
    static CREATE_INTERNAL_MOD_TASK_ASSIGNED = 'task_message.create.internal.mod.task_assigned';

    // Update task message
    static UPDATE = 'task_message.update';

    // Pin / Unpin task message
    static PIN_MANAGE = 'task_message.pin.manage';

    // Archive task message
    static ARCHIVE = 'task_message.archive';

    // Restore task message
    static RESTORE = 'task_message.restore';
}

export default TaskMessagePermission;
